import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.dirtyBlue,
  errorColor: colors.warningRed,
  borderColor: colors.black,
  linkColor: colors.dirtyBlue,
  documentFormBgColor: colors.white,
  documentFormH4Color: colors.black,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default form;